<template>
  <div id="hasbeen">
    <div class="top clearfix">
      <div class="demo-input-suffix status">
        <span class="name">商品状态</span>
        <el-select v-model="typeId" placeholder="请选择" @change="searchList">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </div>
      <div class="demo-input-suffix searchValue">
        <el-input placeholder="请输入内容" v-model="input1">
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
      </div>
      <div class="search" @click="getList('')">搜索</div>
      <div class="button">
        <!-- <el-button class="excelBtn batchShelve" type="primary" icon="el-icon-remove" @click="batchShelve">批量下架</el-button>
        <el-button class="excelBtn " type="primary" v-show='checkStatus != 1' @click="confirmShelve">确认下架</el-button>-->
        <el-button class="excelBtn" type="primary" icon="el-icon-plus" @click="addGoods">添加商品</el-button>
      </div>
    </div>
    <div class="excel">
      <!-- <el-date-picker
        class='picker'
        style="width: 100%;"
        v-model="range"
        @change="handleTimeChange"
        format="yyyy 年 MM 月 dd 日 HH:mm:ss"
        value-format="yyyy-MM-dd HH:mm:ss"
        type="datetimerange"
        range-separator="--"
        :clearable="clear"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :default-time="['00:00:00','23:59:59']"
      >
      </el-date-picker>-->
      <div class="name">时间范围</div>
      <el-date-picker
        v-model="range"
        type="datetimerange"
        @change="handleTimeChange"
        range-separator="--"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :default-time="['00:00:00','23:59:59']"
      ></el-date-picker>
      <div class="excels">
        <el-button class="excelBtn" type="primary" @click="outExcel" :disabled="outExput">导出报表</el-button>
      </div>
    </div>
    <div>
      <div class="center">
        <el-table
          ref="tableData"
          :data="tableData"
          border
          style="width: 100%"
          @selection-change="handleSelectionChange"
          :row-key="getRowKeys"
        >
          <el-table-column
            type="selection"
            v-if="checkStatus != 1"
            :reserve-selection="true"
            align="center"
          ></el-table-column>
          <el-table-column fixed label="编号" align="center" width="55">
            <template slot-scope="scope">{{scope.$index + 1 }}</template>
          </el-table-column>
          <el-table-column fixed prop="logo" label="主图" align="center">
            <template slot-scope="scope">
              <img :src="scope.row.logo" width="80" height="80" />
            </template>
          </el-table-column>
          <el-table-column prop="goodName" label="名称" align="center"></el-table-column>
          <el-table-column prop="preasalePrice" label="预售价格(元)" align="center"></el-table-column>
          <el-table-column prop="presaleCount" label="总销量" align="center">
            <template slot-scope="scope">
              <span>{{scope.row.presaleCount?scope.row.presaleCount:0}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="stock" label="库存" align="center"></el-table-column>
          <el-table-column label="状态" align="center">
            <template slot-scope="scope">
              <span v-show="scope.row.preSaleStatus == 1">进行中</span>
              <span v-show="scope.row.preSaleStatus == 2">已结束</span>
              <span v-show="scope.row.preSaleStatus == 3">预定量不足</span>
            </template>
          </el-table-column>
          <el-table-column width="300" label="开始时间--结束时间" align="center">
            <template slot-scope="scope">
              <span>{{scope.row.stime}}</span>
              <span>--</span>
              <span>{{scope.row.etime}}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="pushEdit(scope.row)">编辑</el-button>
              <el-button
                type="text"
                @click="openUp(scope.row)"
                size="small"
                v-show="scope.row.preSaleStatus !== 1"
              >上架</el-button>
              <el-button
                type="text"
                @click="open(scope.row)"
                size="small"
                v-show="scope.row.preSaleStatus !== 1"
              >下架</el-button>
              <!-- <el-button type="text" size="small" @click="pushRoots(scope.row)">溯源</el-button>
              <el-button type="text" size="small" @click="editStock(scope.row)" :disabled='btnFalse'>修改库存</el-button>
              <el-button type="text" size="small" @click="preSell(scope.row)">预售设置</el-button>-->
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <page v-on:clickPage="clickPage" :currentPage="currentPage" :pageSize="size" :total="total" />
    <el-dialog
      title="库存管理"
      :visible.sync="dialogFormVisible"
      @closed="handleClose"
      class="stock"
      width="30%"
    >
      <el-form ref="ruleForm">
        <el-form-item label="剩余库存">
          <span>{{stock}}</span>
        </el-form-item>
        <el-form-item label="修改库存">
          <el-radio-group v-model="radio" size="mini">
            <el-radio :label="0">增加</el-radio>
            <el-radio :label="1">减少</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="修改数量">
          <el-input placeholder="请输入修改数量" v-model="number"></el-input>
        </el-form-item>
        <el-form-item label="原因">
          <el-input type="textarea" v-model="text" placeholder="最多200字，选填" maxlength="200"></el-input>
        </el-form-item>
        <el-form-item label="操作员">
          <span>{{userName}}</span>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSave">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="预售设置"
      :visible.sync="preFormVisible"
      @closed="handleClose"
      class="preSell"
      width="40%"
    >
      <div class="Modular1">
        <div class="content">
          <el-form ref="form" label-width="100px">
            <div class="presellSet">
              <div class="set">预售设置(预售为全款预售，预售商品不支持加入购物车)</div>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="预售价格(元)">
                    <el-input
                      class="inputItem"
                      v-model="presalePrice"
                      placeholder="请输入，最大999,999,999"
                      maxlength="100"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="预售说明">
                    <el-input
                      class="inputItem"
                      v-model="presaleMark"
                      placeholder="最多30字"
                      oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"
                      maxlength="11"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="预售结束时间">
                    <el-date-picker
                      class="endDate"
                      v-model="endTime"
                      type="datetime"
                      placeholder="选择日期"
                    ></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <div class="num">预售结束后，商品下架</div>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="16">
                  <el-form-item label="已预定量">
                    <div class="endNum">
                      当预售结束后，已预定量少于
                      <el-input
                        placeholder="请输入，最大999"
                        class="inputItem30"
                        v-model="minCount"
                        oninput="value=value.replace(/[^\d]/g,'')"
                        maxlength="11"
                      ></el-input>进行提醒
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="发货时间">
                    <el-radio-group v-model="preRedio">
                      <el-radio class="blex1" label="0">
                        <el-select v-model="sendType" placeholder="请选择" :disabled="preRedio!=="0"">
                          <el-option
                            v-for="item in dateOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          ></el-option>
                        </el-select>
                        <el-input
                          placeholder="请输入，最大999"
                          class="inputItem30"
                          v-model="date1"
                          :disabled="preRedio!=="0""
                          oninput="value=value.replace(/[^\d]/g,'')"
                          maxlength="11"
                        ></el-input>天之内
                      </el-radio>
                      <el-radio class="blex2" label="1">
                        <el-date-picker
                          class="startDate"
                          v-model="date2"
                          type="date"
                          :disabled="preRedio=="0""
                          placeholder="选择日期"
                        ></el-date-picker>开始发货
                      </el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </el-form>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="preFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="handlePreSave">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { shop_url } from "@/global";
import page from "../../components/PageIndex";
import { downloadExcel } from "@/utils/downloadFetch";
import {
  tradeGoods,
  putGoods,
  upadteGoodStatus,
  upadteGoodStock,
  getUserInfo,
  goodsShelve,
  getGoodsExcel,
  setPreGoods,
  getpreSellList,
} from "@/api/goods";
import { mapGetters, mapActions } from "vuex";
export default {
  components: {
    page,
  },

  computed: {
    ...mapGetters(["chooseCompany", "companyList", "mchId"]),
  },
  data() {
    return {
      input1: "",
      currentPage: 1,
      size: 10,
      clear: false,
      total: 0,
      tableData: [],
      dialogFormVisible: false, // 库存弹框显隐
      radio: 0, // 修改类型
      number: "", // 修改数量
      text: "", // 修改原因
      goodId: "", // 商品ID
      stock: "", // 库存数
      userName: "", // 操作员
      btnFalse: false,
      checkStatus: 1, // 批量显示
      checkName: " 批量下架",
      hasSelectgoodsIdList: [],
      getRowKeys(row) {
        return row.goodId;
      },
      range: [],
      clear: false,
      outExput: false,
      options: [
        {
          value: 0,
          label: "全部",
        },
        {
          value: 1,
          label: "进行中",
        },
        {
          value: 2,
          label: "已结束",
        },
        {
          value: 3,
          label: "预定量不足",
        },
      ],
      value: "",
      preFormVisible: false,
      endDate: "", // 结束时间
      startDate: "", //发货时间
      amount: "", // 金额
      explain: "", // 说明
      number: "", // 数量
      preRedio: "0",
      dateOptions: [
        {
          value: 1,
          label: "支付成功",
        },
        {
          value: 2,
          label: "预售结束",
        },
      ],
      selectValue: "",
      // 预售
      endTime: "",
      goodId: "",
      minCount: 0,
      presaleMark: "",
      presalePrice: 0,
      date1: "",
      date2: "",
      sendType: "",
      typeId: "",
    };
  },
  created() {
    let sessionNum = sessionStorage.getItem("preSellPage");
    if (!sessionNum) {
      this.getList();
    } else {
      this.currentPage = Number(sessionNum);
      this.clickPage(this.currentPage);
    }
  },
  methods: {
    handleClick(row) {
      console.log(row);
    },
    handleTimeChange() {},
    outExcel() {
      if (!this.range[0]) {
        this.$message("开始时间不能为空");
        return;
      }
      if (!this.range[1]) {
        this.$message("结束时间不能为空");
        return;
      }
      this.outExput = true;
      let startGetTime = new Date(this.range[0]);
      let start = startGetTime.getTime(startGetTime);
      let endGetTime = new Date(this.range[1]);
      let end = endGetTime.getTime(endGetTime);
      let data = {
        stime: start,
        mchId: this.$store.getters.mchId,
        etime: end,
      };
      console.log(data);
      // console.log(startGetTime);
      // console.log(endGetTime);
      downloadExcel({
        method: "get",
        url: `${shop_url}/shop/shop/v1/report/${data.mchId}/${data.stime}/${data.etime}`,
        fileName: `${this.$store.getters.chooseCompany.name}商品统计报表`,
      })
        .then((res) => {
          this.outExput = false;
          this.$message({
            type: "success",
            message: "表格导出成功",
          });
        })
        .catch((err) => {
          this.outExput = false;
          this.$message({
            type: "error",
            message: "表格导出失败",
          });
        });
    },
    dateFormat: function (row, column) {
      var date = row[column.property];
      if (date == undefined) {
        return "";
      }
      return this.$moment(parseInt(date)).format("YYYY-MM-DD HH:mm:ss");
    },
    clickPage(val) {
      this.currentPage = val;
      window.sessionStorage.setItem("preSellPage", val);
      this.getList();
    },
    // 单品下架
    open(row) {
      const that = this;
      this.$confirm("是否下架该商品，下架后无法购买, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          const id = row.goodId;
          upadteGoodStatus(id, 1).then(function (res) {
            if (res.data == "SUCCESS") {
              that.$message({
                type: "success",
                message: "商品已下架!",
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消下架",
          });
        });
    },
    openUp(row) {
      const that = this;
      this.$confirm("是否上架该商品?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          const id = row.goodId;
          upadteGoodStatus(id, 0).then(function (res) {
            if (res.code == 1) {
              that.$message({
                type: "success",
                message: "商品已上架!",
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消上架",
          });
        });
    },
    addGoods() {
      this.$router.push({
        path: "/main/storeUp/addStore",
      });
    },
    pushRoots(row) {
      const id = row.goodId;
      this.$router.push({
        name: "Roots",
        params: { id },
      });
    },
    getList(typeId) {
      let that = this;
      let data = {
        categoryId: null,
        goodName: this.input1 ? this.input1 : "",
        mchId: this.chooseCompany.id,
        page: this.currentPage,
        pageCount: 10,
        status: -1,
        orderBy: 2,
        lifting: 1,
        stockOrder: 0,
        typeId: typeId ? typeId : "",
      };
      getpreSellList(data).then((res) => {
        // console.log(res);
        that.tableData = res.data.list;
        console.log(that.tableData);
        that.tableData.forEach((item) => {
          item.employeePrice = that.regFenToYuan(item.employeePrice);
          item.etime = that.getDateString(item.etime);
          item.stime = that.getDateString(item.stime);
          item.price = that.regFenToYuan(item.price);
          item.preasalePrice = that.regFenToYuan(item.preasalePrice);
        });
        // this.total = res.data.count[0].count
      });
    },
    regFenToYuan(fen) {
      var num = fen;
      num = fen * 0.01;
      num += "";
      var reg =
        num.indexOf(".") > -1
          ? /(\d{1,3})(?=(?:\d{3})+\.)/g
          : /(\d{1,3})(?=(?:\d{3})+$)/g;
      num = num.replace(reg, "$1");
      num = this.toDecimal2(num);
      return num;
    },
    toDecimal2(x) {
      var f = parseFloat(x);
      if (isNaN(f)) {
        return false;
      }
      var f = Math.round(x * 100) / 100;
      var s = f.toString();
      var rs = s.indexOf(".");
      if (rs < 0) {
        rs = s.length;
        s += ".";
      }
      while (s.length <= rs + 2) {
        s += "0";
      }
      return s;
    },
    pushEdit(row) {
      const id = row.goodId;
      const status = row.status;
      const preSaleStatus = row.preSaleStatus;
      this.$router.push({
        name: "Edits",
        query: { id, status, preSaleStatus },
      });
    },
    async editStock(row) {
      console.log(row);
      this.userInfo();
      this.dialogFormVisible = true;
      this.goodId = row.goodId;
      this.stock = row.stock;
      console.log(this.goodId);
    },
    handleClose() {
      this.dialogFormVisible = false;
    },
    handleSave(row) {
      this.btnFalse = true;
      if (this.number == 0) {
        this.$message("修改数量不能为空");
        return;
      }
      if (this.goodId == "") {
        this.$message("修改数量不能为空");
        return;
      }
      let data = {
        count: this.number,
        goodId: this.goodId,
        mark: this.text,
        type: this.radio === 0 ? 1 : 2,
      };
      upadteGoodStock(data)
        .then((res) => {
          if (res.code == 1) {
            this.$message("修改成功");
            this.dialogFormVisible = false;
            this.number = "";
            this.text = "";
            this.getList();
            this.btnFalse = false;
          }
        })
        .catch((err) => {
          console.log(err);
          this.btnFalse = false;
        });
    },
    async userInfo() {
      let res = await getUserInfo();
      this.userName = res.data.nickName;
    },
    // 批量下架
    batchShelve() {
      this.checkStatus = this.checkStatus == 1 ? 0 : 1;
      // console.log(this.checkStatus);
    },
    // 确认下架
    confirmShelve() {
      let that = this;
      if (!that.hasSelectgoodsIdList.length) {
        that.$message({
          message: "请选择上架商品",
        });
        return;
      }
      this.$confirm("是否下架该商品，下架后无法购买, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          const data = {
            goodIds: this.hasSelectgoodsIdList,
            status: 1,
          };
          goodsShelve(data).then(function (res) {
            if (res.msg == "success") {
              that.$message({
                type: "success",
                message: "商品已下架!",
              });
              that.getList();
              that.checkStatus = 1;
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消下架",
          });
        });
    },
    // 选择商品
    handleSelectionChange(e) {
      if (e.length) {
        let goodsId = [];
        e.forEach((item) => {
          goodsId.push(item.goodId);
        });
        this.hasSelectgoodsIdList = goodsId;
        console.log(this.hasSelectgoodsIdList);
      }
    },
    preSell(e) {
      this.goodId = e.goodId;
      this.preFormVisible = true;
    },
    handlePreSave() {
      this.open2();
    },
    open2() {
      if (!this.presalePrice) {
        this.$message("商品预售价格必不能为空");
        return;
      }
      if (!this.endTime) {
        this.$message("商品预售结束时间必不能为空");
        return;
      }
      if (!this.minCount) {
        this.$message("商品最小预售量不能为空");
        return;
      }
      if (!this.sendTime) {
        this.$message("商品发送时间不能为空");
        return;
      }
      if (!this.sendType) {
        this.$message("商品发送类型不能为空");
        return;
      }
      this.$confirm("开启后商品将按照预售设置进行售卖", "确定开启商品预售", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let data = {
            goodId: this.goodId,
            endTime: this.endTime,
            minCount: this.minCount,
            presaleMark: this.presaleMark,
            presalePrice: this.presalePrice,
            sendTime: this.preRedio == 0 ? this.date1 : this.date2,
            sendType: this.preRedio == 1 ? "3" : this.sendType,
          };
          console.log(data);
          setPreGoods(data).then((res) => {
            console.log(res);
            this.goodId = "";
            this.endTime = "";
            this.minCount = "";
            this.presaleMark = "";
            this.presalePrice = "";
            this.date1 = "";
            this.sendType = "";
            this.preFormVisible = false;
            this.$message({
              type: "success",
              message: "设置预售成功!",
            });
          });
        })
        .catch(() => {
          this.preFormVisible = false;
        });
    },
    getDateString(stamp) {
      let d = new Date(parseInt(stamp));
      let month =
        d.getMonth() + 1 < 10 ? 0 + "" + (d.getMonth() + 1) : d.getMonth() + 1;
      let day = d.getDate() < 10 ? 0 + "" + d.getDate() : d.getDate();
      let hour = d.getHours() < 10 ? 0 + "" + d.getHours() : d.getHours();
      let minute =
        d.getMinutes() < 10 ? 0 + "" + d.getMinutes() : d.getMinutes();
      let second =
        d.getSeconds() < 10 ? 0 + "" + d.getSeconds() : d.getSeconds();
      let dateString =
        d.getFullYear() + "-" + month + "-" + day + " " + hour + ":" + minute;
      return dateString;
    },
    searchList(event, item) {
      // console.log(event, item);
      this.page = 1;
      this.typeId = event;
      this.getList(event);
    },
  },
};
</script>
<style lang="scss" scoped>
.clearfix:after {
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}

#hasbeen {
  width: 100%;
  height: 100%;
  padding: 27px 13px;
  box-sizing: border-box;
  .top {
    .demo-input-suffix {
      width: 220px;
      float: left;
    }
    .search {
      float: left;
      width: 50px;
      height: 40px;
      text-align: center;
      line-height: 40px;
      cursor: pointer;
    }
    .searchValue {
      margin-left: 20px;
    }
    .button {
      float: right;
      .excelBtn {
        width: 120px;
        background-color: #0891d7;
      }
    }
    .status {
      display: flex;
      align-items: center;
      .name {
        width: 120px;
      }
    }
  }
  .excel {
    display: flex;
    align-items: center;
    margin-top: 20px;
    .name {
      width: 78px;
    }
    .picker {
      flex-basis: 50%;
    }
    .excels {
      flex: 1;
      display: flex;
      justify-content: flex-end;
      .excelBtn {
        width: 120px;
        background-color: #0891d7;
      }
    }
  }
  .center {
    margin-top: 25px;
  }
  .stock {
    /deep/ .el-form-item {
      margin-bottom: 22px;
      display: flex;
      .el-form-item__label {
        width: 100px;
      }
      .el-form-item__content {
        flex: 1;
      }
    }
  }
}
.preSell {
  .presellSet {
    .set {
      font-size: 14px;
      color: #606266;
      margin-bottom: 20px;
    }
    .blex1 {
      display: flex;
      align-items: center;
      font-size: 14px;
      color: #606266;
    }
    .blex2 {
      display: flex;
      align-items: center;
      margin-top: 20px;
      font-size: 14px;
      color: #606266;
    }
    .num {
      font-size: 14px;
      color: #606266;
      line-height: 40px;
      margin-left: 5px;
    }
    .endNum {
      font-size: 14px;
      color: #606266;
    }
    .inputItem30 {
      width: 30%;
    }
  }
  .check {
    padding-bottom: 20px;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/store/preSellList.vue